<template>
  <v-toolbar color="gray" flat>
    <v-avatar :size="45" v-if="avatar">
      <cloudinary-image
        :id="avatar.public_id"
        :version="avatar.version"
        :type="avatar.resource_type"
        transformation="h_120,w_120,q_auto,f_jpg,g_faces:center,c_fill"
      />
    </v-avatar>
    <v-toolbar-title>
      <div class="font-weight-bold">{{ title }}</div>
      <div class="caption">
        <div v-if="muser || mdate">
          <strong class="mr-1">Ultima modifica</strong>
          <span v-if="muser" class="mr-1">{{ muser }},</span>
          {{ mdate | formatDate('dd/MM/Y - HH:mm') }}
        </div>
      </div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <slot name="badges"></slot>
    </v-toolbar-items>
    <v-btn icon @click="$router.push(closePath)">
      <v-icon>close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import cloudinaryImage from '@/components/common/CloudinaryImage'
import _ from 'lodash'
export default {
  props: ['title', 'muser', 'mdate', 'closeRoute', 'avatar'],
  components: {
    cloudinaryImage
  },
  computed: {
    closePath: function (params) {
      return _.isObject(this.closeRoute) ? this.closeRoute : { name: this.closeRoute, query: { ...this.$route.query } }
    }
  }
}
</script>

<style>
.v-toolbar__items {
  height: auto;
}
</style>
